// DANH SÁCH NHÓM CỦA NICK (người dùng duyệt 2026-10-04) — dùng chung bot + Boss. Bot gửi lên Boss nhóm Facebook của nick đang đăng nhập kèm trạng thái
// (đã vào / chưa vào / chờ duyệt / có câu hỏi) từ 3 nguồn: kết quả TÌM NHÓM, kết quả bước XIN VÀO, trang "Nhóm của bạn" (đọc đủ bằng cách cuộn).
// Boss lưu theo bot + nick, trang "Nhóm của nick" lọc theo từ khoá. Bước xin vào bỏ nhóm Boss đã biết là đã vào / chờ duyệt / có câu hỏi.
import { normText } from "./vi";

export type TrangThaiNhom = "da_tham_gia" | "chua_tham_gia" | "cho_duyet" | "co_cau_hoi" | "khong_ro";
export const TRANG_THAI_NHOM: readonly TrangThaiNhom[] = ["da_tham_gia", "chua_tham_gia", "cho_duyet", "co_cau_hoi", "khong_ro"];
export const NHAN_TRANG_THAI: Record<TrangThaiNhom, string> = { da_tham_gia: "Đã vào", chua_tham_gia: "Chưa vào", cho_duyet: "Chờ duyệt", co_cau_hoi: "Có câu hỏi", khong_ro: "Chưa rõ" };
export type NguonNhom = "tim_nhom" | "tham_gia" | "nhom_cua_ban";
export const NGUON_NHOM: readonly NguonNhom[] = ["tim_nhom", "tham_gia", "nhom_cua_ban"];

export interface NhomBao { url: string; ten: string; trangThai: TrangThaiNhom; thanhVien?: string; cheDo?: string }
export interface BaoNhomNick { mang: "facebook"; nickId: string; nickTen: string; nguon: NguonNhom; tuKhoa?: string; nhom: NhomBao[] }

export const TOI_DA_NHOM = 2000;
const TEN_TOI_DA = 200;
const HE_THONG = /^(joins|feed|discover|create|notifications|your_groups|search|category|discover_projects)$/i;

const catKyTu = (s: string, n: number): string => Array.from(s).slice(0, n).join("");

/** Địa chỉ nhóm chuẩn "<giao thức>//<máy>/groups/<mã>/" (Facebook → https://www.facebook.com). Không phải nhóm / trang hệ thống → null. */
export function chuanUrlNhom(raw: unknown): string | null {
  if (typeof raw !== "string") return null;
  const s = raw.trim();
  if (!s || s.length > 500 || (!s.startsWith("/") && !/^https?:\/\//i.test(s))) return null;
  let u: URL;
  try { u = new URL(s, "https://www.facebook.com"); } catch { return null; }
  const m = /^\/groups\/([^/?#]+)/.exec(u.pathname);
  if (!m || HE_THONG.test(m[1]!)) return null;
  let host = u.host.toLowerCase();
  const laFb = /^(?:www\.|m\.|mbasic\.|web\.)?(?:facebook\.com|fb\.com)$/.test(host);
  if (laFb) return `https://www.facebook.com/groups/${m[1]}/`;
  host = host.replace(/^(?:www|m)\./, "");
  return `${u.protocol}//${host}/groups/${m[1]}/`;
}

const trangThaiCua = (v: unknown): TrangThaiNhom => (typeof v === "string" && (TRANG_THAI_NHOM as readonly string[]).includes(v) ? (v as TrangThaiNhom) : "khong_ro");
const chuoiGon = (v: unknown, n: number): string => (typeof v === "string" ? catKyTu(v.replace(/\s+/g, " ").trim(), n) : "");

/** Danh sách nhóm (mục extract) → nhóm chuẩn. Nhận ten_nhom/nhom_url/trang_thai/thanh_vien/che_do (tìm nhóm) hoặc ten/url (Nhóm của bạn).
 *  macDinh: trạng thái khi mục không có (trang "Nhóm của bạn" → da_tham_gia). Gộp trùng địa chỉ (mục đầu thắng), tối đa TOI_DA_NHOM. */
export function nhomTuDanhSach(ds: unknown, macDinh?: TrangThaiNhom): NhomBao[] {
  if (!Array.isArray(ds)) return [];
  const out = new Map<string, NhomBao>();
  for (const x of ds) {
    if (out.size >= TOI_DA_NHOM) break;
    if (!x || typeof x !== "object" || Array.isArray(x)) continue;
    const o = x as Record<string, unknown>;
    const url = chuanUrlNhom(o.nhom_url ?? o.url);
    if (!url || out.has(url)) continue;
    const ten = chuoiGon(o.ten_nhom ?? o.ten, TEN_TOI_DA) || decodeURIComponent(/\/groups\/([^/]+)\/$/.exec(url)![1]!);
    const tt = o.trang_thai === undefined && macDinh ? macDinh : trangThaiCua(o.trang_thai);
    const n: NhomBao = { url, ten, trangThai: tt };
    const tv = chuoiGon(o.thanh_vien, 40);
    if (tv) n.thanhVien = tv;
    const cd = chuoiGon(o.che_do, 40);
    if (cd) n.cheDo = cd;
    out.set(url, n);
  }
  return [...out.values()];
}

/** Tên nhóm có chứa ĐỦ các từ của từ khoá không (bỏ dấu, không phân biệt hoa thường; so chuỗi thường — không phải biểu thức chính quy). Rỗng → có. */
export function khopTuKhoa(ten: string, q: string): boolean { return taoKhopTuKhoa(q)(ten); }
/** Như khopTuKhoa nhưng chuẩn hoá từ khoá MỘT lần rồi dùng cho nhiều tên (lọc 1500 nhóm không phải chuẩn hoá lại từ khoá 1500 lần). */
export function taoKhopTuKhoa(q: string): (ten: string) => boolean {
  const tu = normText(q ?? "").split(/\s+/).filter(Boolean);
  if (!tu.length) return () => true;
  return (ten) => { const t = normText(ten ?? ""); return tu.every((w) => t.includes(w)); };
}

// ---- "Đọc lại / Cập nhật" nhóm của bot: bot đang đọc thì máy chủ trả 409 trong DANG_DOC_MS (13/10/2026: trang nhớ lệnh đã ra để KHÔNG gửi lệnh thứ hai — yêu cầu 409 nào cũng
// bị trình duyệt ghi một dòng đỏ vào console, bộ khỉ hạt 101/102 bắt được) ----
export const DANG_DOC_MS = 3 * 60_000;
export const MSG_DANG_DOC = "Bot đang đọc danh sách nhóm — chờ vài phút rồi tải lại trang";
/** Bảng "đã ra lệnh đọc lại cho bot nào lúc nào" (ms). */
export type LenhDocLai = Record<string, number>;
/** Bot này còn đang đọc (đã ra lệnh chưa quá DANG_DOC_MS)? */
export function dangDocNhom(lenh: LenhDocLai, botId: string, now: number): boolean {
  const t = lenh[botId];
  return typeof t === "number" && now - t >= 0 && now - t < DANG_DOC_MS;
}
/** Bảng mới sau khi ghi lệnh cho `botId` (bỏ các dòng đã quá hạn; không sửa bảng gốc). */
export function ghiLenhDocLai(lenh: LenhDocLai, botId: string, now: number): LenhDocLai {
  const moi: LenhDocLai = {};
  for (const [k, t] of Object.entries(lenh)) if (typeof t === "number" && now - t >= 0 && now - t < DANG_DOC_MS) moi[k] = t;
  moi[botId] = now;
  return moi;
}
